import {
  NativeDialog as Dialog,
  NativeDialogContent as DialogContent,
  NativeDialogDescription as DialogDescription,
  NativeDialogHeader as DialogHeader,
  NativeDialogTitle as DialogTitle,
  Button,
  SocialLoginButton,
} from "@ad3d/ui";
import { useState } from "react";
import { supabase } from "@ad3d/supabase";

export function LoginModal({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleGoogleLogin = async () => {
    setIsSubmitting(true);
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: window.location.href,
      },
    });
    if (error) {
      console.error(error);
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Login Required</DialogTitle>
          <DialogDescription>
            Please sign in to access this feature.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <SocialLoginButton
            provider="google"
            animation="slide"
            className="w-full md:w-full"
            onClick={handleGoogleLogin}
            loading={isSubmitting}
          >
            Sign in with Google
          </SocialLoginButton>
        </div>
      </DialogContent>
    </Dialog>
  );
}
